import type { VisibilityState } from "@tanstack/react-table";
import { DataTable } from "@/components/custom/table/data-table";
import { DataTableContent } from "@/components/custom/table/data-table-content";
import { DataTablePagination } from "@/components/custom/table/data-table-pagination";
import type { McpServer } from "../../types";
import { gatewayColumns } from "./columns";

export const GatewaysTable = ({
  items,
  columnVisibility,
  onColumnVisibilityChange,
}: {
  items: McpServer[];
  columnVisibility?: VisibilityState;
  onColumnVisibilityChange?: (
    updater: VisibilityState | ((old: VisibilityState) => VisibilityState)
  ) => void;
}) => (
  <DataTable
    className="space-y-4"
    columns={gatewayColumns}
    columnVisibility={columnVisibility}
    data={items}
    defaultPageSize={5}
    getRowId={(row) => row.id}
    onColumnVisibilityChange={onColumnVisibilityChange}
  >
    <DataTableContent stickyColumnBg="background" />
    <DataTablePagination />
  </DataTable>
);
